import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed, dynamicSuccess } from "../hooks/custom/useToast";
// import { fetchFooterDetails } from "../api/FooterApi";
// import { IFooterDetailsData } from "../exports/interfaces";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { useBrochureContext } from "../context/BrochureContext";
import {
  IAcademicsMenuCoursesData,
  IAcademicsMenuProgramsData,
} from "../exports/interfaces";
import { stripHtml } from "../exports/functions";

interface HeaderSidebarProps {
  showSidebar: boolean;
  toggleSidebar: () => void;
  openViewer: (path: string) => void;
  academicsMenuPrograms: IAcademicsMenuProgramsData[];
  academicsMenuCourses: IAcademicsMenuCoursesData[];
}

export const HeaderSidebar: React.FC<HeaderSidebarProps> = ({
  showSidebar,
  toggleSidebar,
  openViewer,
  academicsMenuPrograms,
  academicsMenuCourses,
}) => {
  const { setLoading } = useLoader();
  const { brochureData, undergraduateBrochureData, mppBrochureData } =
    useBrochureContext();

  const { companyDetailsData } = useCompanyDetailsContext();

  const [subscribeEmail, setSubscribeEmail] = React.useState("");

  const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({});

  const toggleMenu = (key: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const closeSidebar = () => {
    toggleSidebar();
    setOpenMenus({});
  };

  const location = useLocation();
  const navigate = useNavigate();

  const programs = academicsMenuPrograms.map((program) => {
    return {
      title: program.title,
      color: program.color_code,
      icon: program.icon_code,
      icon_image: program.icon_image,
      courses: academicsMenuCourses
        .filter((course) => course.program_name === program.title)
        .map((course) => course.name),
    };
  });

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isValidEmail(subscribeEmail)) {
      dynamicFailed("Please enter a valid email address!");
      return;
    }

    setLoading(true);

    const data = {
      email: subscribeEmail,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/subscribe`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        setSubscribeEmail("");
        dynamicSuccess("Subscribed successfully!");
        setLoading(false);
      } else {
        dynamicFailed("Subscription failed!");
        setLoading(false);
      }
    } catch (error: any) {
      dynamicFailed("Subscription failed!");
      setLoading(false);
    }
  };

  // const [footerDetails, setFooterDetails] = useState<IFooterDetailsData[]>([]);

  // useEffect(() => {
  //   Promise.all([fetchFooterDetails()])
  //     .then(([footerDetailsData]) => {
  //       setFooterDetails(footerDetailsData);
  //     })
  //     .catch((error) => {
  //       dynamicFailed(error.response.data.error.message);
  //     });
  // }, []);

  const handleMenuClick = (
    e: React.MouseEvent<HTMLElement>,
    pathname: string,
    hash: string,
  ) => {
    e.preventDefault();
    closeSidebar();

    if (
      location.pathname === `/${pathname}` ||
      (pathname === "" && location.pathname === "/")
    ) {
      document.getElementById(hash)?.scrollIntoView({
        behavior: "smooth",
      });
    } else {
      navigate(`/${pathname}#${hash}`);
    }
  };

  const handleMenuClickToTab = (
    e: React.MouseEvent<HTMLAnchorElement>,
    pathname: string,
    hash: string,
    idToScroll?: string,
  ) => {
    e.preventDefault();

    closeSidebar();

    const targetHash = `#${hash}`;

    if (location.pathname === `/${pathname}`) {
      // update URL hash
      window.history.replaceState(null, "", targetHash);

      // activate tab
      const tabLink = document.querySelector(
        `.td_tab_links a[href="${targetHash}"]`,
      ) as HTMLAnchorElement | null;

      tabLink?.click();

      // scroll to tabs
      document.querySelector(idToScroll || ".td_tabs")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      navigate(`/${pathname}${targetHash}`);
    }
  };

  return (
    <div className={`td_side_header ${showSidebar && "active"}`}>
      <button className="td_close" onClick={closeSidebar} />

      <div className="td_side_header_overlay" onClick={closeSidebar} />

      <div className="td_side_header_in">
        <div className="td_side_header_shape" />
        <Link to="/" className="td_site_branding sidebar_td_site_branding">
          <img
            src={`${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color[0]?.media?.url}`}
            alt="Logo"
          />
        </Link>

        {/* <div className="td_side_header_box">
          <h2 className="td_fs_18 custom-text-p">
            {footerDetails[0]?.description}
          </h2>
        </div> */}
        <div className="sidebar_td_main_header_center">
          <nav className="sidebar_td_nav">
            <div className="sidebar_td_nav_list_wrap w-100" id="sidebar">
              <div className="sidebar_td_nav_list_wrap_in">
                <ul className="sidebar_td_nav_list">
                  <li>
                    <Link
                      to="/"
                      className="td_accent_color"
                      style={{ fontWeight: "bold" }}
                      onClick={closeSidebar}
                    >
                      Home
                    </Link>
                  </li>
                  <li
                    className={`menu-item-has-children td_mega_menu ${openMenus.about ? "open" : ""}`}
                  >
                    <div
                      className="menu-title"
                      onClick={() => toggleMenu("about")}
                    >
                      <Link
                        to="/about"
                        className="td_accent_color"
                        onClick={closeSidebar}
                        style={{ fontWeight: "bold" }}
                      >
                        About
                      </Link>

                      <span className="menu-toggle">
                        {openMenus.about ? "−" : "+"}
                      </span>
                    </div>
                    <ul className="td_mega_wrapper">
                      <li
                        className={`menu-item-has-children ${openMenus.introduction ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("introduction")}
                        >
                          <h4>Introduction</h4>
                          <span className="menu-toggle">
                            {openMenus.introduction ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link
                              to="/about#introduction1"
                              onClick={(e) =>
                                handleMenuClick(e, "about", "introduction")
                              }
                            >
                              Our Story
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about#why-unepal"
                              onClick={(e) =>
                                handleMenuClick(e, "about", "why-unepal")
                              }
                            >
                              Why UNepal?
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about#vision-mission"
                              onClick={(e) =>
                                handleMenuClick(e, "about", "vision-mission")
                              }
                            >
                              Vision, Mission & Core Values
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                closeSidebar();
                                openViewer(
                                  brochureData[0]?.file &&
                                    brochureData[0]?.file.length > 0
                                    ? brochureData[0]?.file[0]?.media?.url
                                    : stripHtml(brochureData[0]?.link),
                                );
                              }}
                            >
                              Our Brochure
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li
                        className={`menu-item-has-children ${openMenus.philosophy ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("philosophy")}
                        >
                          <h4>Academic Philosophy</h4>
                          <span className="menu-toggle">
                            {openMenus.philosophy ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link
                              to="/about"
                              // to="/about#td_tab_3"
                              // onClick={(e) =>
                              //   handleMenuClickToTab(
                              //     e,
                              //     "about",
                              //     "td_tab_3"
                              //   )
                              // }
                            >
                              Liberal Arts & Sciences
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li
                        className={`menu-item-has-children ${openMenus.leadership ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("leadership")}
                        >
                          <h4>Leadership</h4>
                          <span className="menu-toggle">
                            {openMenus.leadership ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link
                              to="/about#td_message_tab_1"
                              onClick={(e) =>
                                handleMenuClickToTab(
                                  e,
                                  "about",
                                  "td_message_tab_1",
                                  ".td_message_tabs",
                                )
                              }
                            >
                              Chancellor Message
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about#td_message_tab_2"
                              onClick={(e) =>
                                handleMenuClickToTab(
                                  e,
                                  "about",
                                  "td_message_tab_2",
                                  ".td_message_tabs",
                                )
                              }
                            >
                              Vice Chancellor Message
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about#board-of-trustees"
                              onClick={(e) =>
                                handleMenuClick(e, "about", "board-of-trustees")
                              }
                            >
                              BoT and Executives Information
                            </Link>
                          </li>
                          <li>
                            <Link to="/advisors" onClick={closeSidebar}>
                              World-Class Academic Standards & Advisors
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li
                        className={`menu-item-has-children ${openMenus.act ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("act")}
                        >
                          <h4>Act</h4>
                          <span className="menu-toggle">
                            {openMenus.act ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link
                              to={`${process.env.REACT_APP_URL}/uploads/announcements/%E0%A4%A8%E0%A5%87%E0%A4%AA%E0%A4%BE%E0%A4%B2%20%E0%A4%B5%E0%A4%BF%E0%A4%B6%E0%A5%8D%E0%A4%B5%E0%A4%B5%E0%A4%BF%E0%A4%A6%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%B2%E0%A4%AF%20%E0%A4%90%E0%A4%A8,%20%E0%A5%A8%E0%A5%A6%E0%A5%AE%E0%A5%A7.pdf`}
                              target="_blank"
                              rel="noreferrer noopener"
                              onClick={closeSidebar}
                            >
                              Act & Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.REACT_APP_URL}/uploads/announcements/मनोनयनका%20लागि%20सिफारिस%20सम्बन्धी%20नियमावली,%20२०८१.pdf`}
                              target="_blank"
                              rel="noreferrer noopener"
                              onClick={closeSidebar}
                            >
                              Rules & Regulations
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`menu-item-has-children ${openMenus.academics ? "open" : ""}`}
                  >
                    <div
                      className="menu-title"
                      onClick={() => toggleMenu("academics")}
                    >
                      <Link
                        to="/sast"
                        style={{ fontWeight: "bold" }}
                        onClick={closeSidebar}
                      >
                        Academics
                      </Link>
                      <span className="menu-toggle">
                        {openMenus.academics ? "−" : "+"}
                      </span>
                    </div>
                    <ul className="td_mega_wrapper">
                      <h4>
                        <Link to="/sast" className="p-0" onClick={closeSidebar}>
                          School of Arts, Sciences & Technology (SAST)
                        </Link>
                      </h4>
                      <li
                        className={`menu-item-has-children ${openMenus.undergraduate ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("undergraduate")}
                        >
                          <h4
                            style={{
                              padding: "12px",
                            }}
                          >
                            Undergraduate Programs
                          </h4>
                          <span className="menu-toggle">
                            {openMenus.undergraduate ? "−" : "+"}
                          </span>
                        </div>

                        <ul className="td_mega_wrapper">
                          {programs.map((program, index) => {
                            const programKey = `program-${index}`;

                            return (
                              <li
                                key={index}
                                className={`menu-item-has-children ${
                                  openMenus[programKey] ? "open" : ""
                                }`}
                              >
                                <div
                                  className="menu-title"
                                  onClick={() => toggleMenu(programKey)}
                                >
                                  <h4
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      padding: "12px",
                                    }}
                                  >
                                    {program.icon_image ? (
                                      <img
                                        src={`${process.env.REACT_APP_cmsUrl}${program?.icon_image?.[0]?.media?.url}`}
                                        alt={program.title}
                                        className="d-block"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    ) : (
                                      <i className={program.icon}></i>
                                    )}

                                    {program.title}
                                  </h4>

                                  <span className="menu-toggle">
                                    {openMenus[programKey] ? "−" : "+"}
                                  </span>
                                </div>

                                <ul>
                                  {program.courses?.map((course, i) => (
                                    <li key={i}>
                                      <Link
                                        to={`/sast/${program.title}/${course}`}
                                        onClick={closeSidebar}
                                        style={{ paddingLeft: "40px" }}
                                      >
                                        {course}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                      <Link
                        to="#"
                        className="ms-3"
                        onClick={() => {
                          closeSidebar();
                          openViewer(
                            undergraduateBrochureData[0]?.file &&
                              undergraduateBrochureData[0]?.file.length > 0
                              ? undergraduateBrochureData[0]?.file[0]?.media
                                  ?.url
                              : stripHtml(undergraduateBrochureData[0]?.link),
                          );
                        }}
                      >
                        Undergraduate Brochure
                      </Link>
                      <h4>School of Public Policy (SPP)</h4>
                      <li
                        className={`menu-item-has-children ${openMenus.graduate ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("graduate")}
                        >
                          <h4
                            style={{
                              padding: "12px",
                            }}
                          >
                            Graduate Programs
                          </h4>
                          <span className="menu-toggle">
                            {openMenus.graduate ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link
                              to="/mpp"
                              onClick={() => {
                                closeSidebar();
                              }}
                              style={{ paddingLeft: "45px" }}
                            >
                              Master of Public Policy (MPP)
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <Link
                        to="#"
                        className="ms-3"
                        onClick={() => {
                          closeSidebar();
                          openViewer(
                            mppBrochureData[0]?.file &&
                              mppBrochureData[0]?.file.length > 0
                              ? mppBrochureData[0]?.file[0]?.media?.url
                              : stripHtml(mppBrochureData[0]?.link),
                          );
                        }}
                      >
                        MPP Brochure
                      </Link>
                    </ul>
                    {/* </li> */}
                    {/* </ul> */}
                  </li>
                  <li
                    className={`menu-item-has-children ${openMenus.admissions ? "open" : ""}`}
                  >
                    <div
                      className="menu-title"
                      onClick={() => toggleMenu("admissions")}
                    >
                      <Link
                        to="/"
                        className="td_accent_color"
                        style={{ fontWeight: "bold" }}
                        onClick={closeSidebar}
                      >
                        Admissions & Aids
                      </Link>
                      <span className="menu-toggle">
                        {openMenus.admissions ? "−" : "+"}
                      </span>
                    </div>
                    <ul>
                      <li>
                        <Link to="/sast" onClick={closeSidebar}>
                          Undergraduate
                        </Link>
                      </li>
                      <li>
                        <Link to="/mpp" onClick={closeSidebar}>
                          Graduate
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/application-form#financial-aid"
                          // to="/mpp#td_tab_5"
                          // onClick={(e) =>
                          //   handleMenuClickToTab(e, "mpp", "td_tab_5")
                          // }
                        >
                          Financial Aid & Scholarships
                        </Link>
                      </li>
                      <li>
                        <Link to="/application-form" onClick={closeSidebar}>
                          Apply Now
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`menu-item-has-children ${openMenus.notice ? "open" : ""}`}
                  >
                    <div
                      className="menu-title"
                      onClick={() => toggleMenu("notice")}
                    >
                      <Link
                        to="#notice_tab_1"
                        className="td_accent_color"
                        style={{ fontWeight: "bold" }}
                        onClick={(e) =>
                          handleMenuClickToTab(
                            e,
                            "",
                            "notice_tab_1",
                            ".td_notice_tabs",
                          )
                        }
                      >
                        Public Notice
                      </Link>
                      <span className="menu-toggle">
                        {openMenus.notice ? "−" : "+"}
                      </span>
                    </div>
                    <ul>
                      <li
                        className={`menu-item-has-children ${openMenus.vacancy ? "open" : ""}`}
                      >
                        <div
                          className="menu-title"
                          onClick={() => toggleMenu("vacancy")}
                        >
                          <Link to="/vacancy" onClick={closeSidebar}>
                            Vacancy
                          </Link>
                          <span className="menu-toggle">
                            {openMenus.vacancy ? "−" : "+"}
                          </span>
                        </div>
                        <ul>
                          <li>
                            <Link to="/vacancy#academic" onClick={closeSidebar}>
                              Academic Post
                            </Link>
                          </li>
                          <li>
                            <Link to="/vacancy#admin" onClick={closeSidebar}>
                              Admin Post
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link
                          to="#notice_tab_3"
                          onClick={(e) =>
                            handleMenuClickToTab(
                              e,
                              "",
                              "notice_tab_3",
                              ".td_notice_tabs",
                            )
                          }
                        >
                          Procurement Notice
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#notice_tab_4"
                          onClick={(e) =>
                            handleMenuClickToTab(
                              e,
                              "",
                              "notice_tab_4",
                              ".td_notice_tabs",
                            )
                          }
                        >
                          Expression of Interest
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#notice_tab_5"
                          onClick={(e) =>
                            handleMenuClickToTab(
                              e,
                              "",
                              "notice_tab_5",
                              ".td_notice_tabs",
                            )
                          }
                        >
                          Others
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`menu-item-has-children ${openMenus.community ? "open" : ""}`}
                  >
                    <div
                      className="menu-title"
                      onClick={() => toggleMenu("community")}
                    >
                      <Link
                        to="/community-university"
                        className="td_accent_color"
                        style={{ fontWeight: "bold" }}
                        onClick={closeSidebar}
                      >
                        Community
                      </Link>
                      <span className="menu-toggle">
                        {openMenus.community ? "−" : "+"}
                      </span>
                    </div>
                    <ul>
                      <li>
                        <Link to="/community-university" onClick={closeSidebar}>
                          Building for Future
                        </Link>
                      </li>
                      <li>
                        <Link to="/community-faculty" onClick={closeSidebar}>
                          Join as Faculty
                        </Link>
                      </li>
                      <hr />
                      <li>
                        <Link
                          to="/community-university#campus-idea"
                          onClick={(e) =>
                            handleMenuClick(
                              e,
                              "community-university",
                              "campus-idea",
                            )
                          }
                        >
                          Our Idea of Campus as Community
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="td_accent_color"
                      style={{ fontWeight: "bold" }}
                      onClick={closeSidebar}
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
                {/* {(mobile || tab) && (
                  <div className="div-give-button">
                    <Link
                      to="/community-university#ways-to-give"
                      className="td_btn td_style_1 td_radius_10 td_medium"
                      onClick={(e) =>
                        handleMenuClick(
                          e,
                          "community-university",
                          "ways-to-give",
                        )
                      }
                    >
                      <span className="td_btn_in td_white_color give_btn">
                        <span>Give</span>
                        <i className="fa fa-heart"></i>
                      </span>
                    </Link>
                  </div>
                )} */}
              </div>
            </div>
          </nav>
        </div>
        <div className="td_side_header_box">
          <h3 className="td_side_header_title td_heading_color">Contact Us</h3>
          <ul className="td_side_header_contact_info td_mp_0">
            <li>
              <i className="fa-solid fa-phone"></i>
              <a href={`tel:${companyDetailsData[0]?.telephone_number}`}>
                {companyDetailsData[0]?.telephone_number}
              </a>
            </li>
            <li>
              <i className="fa-solid fa-mobile"></i>
              <a href={`tel:${companyDetailsData[0]?.mobile_number}`}>
                {companyDetailsData[0]?.mobile_number}
              </a>
            </li>
            <li>
              <i className="fa-solid fa-envelope"></i>
              <a href={`mailto:${companyDetailsData[0]?.email}`}>
                {companyDetailsData[0]?.email}
              </a>
            </li>
            <li>
              <i className="fa-solid fa-location-dot"></i>
              <a
                href={companyDetailsData[0]?.get_direction}
                target="_blank"
                rel="noopener noreferrer"
              >
                {companyDetailsData[0]?.company_address}
              </a>
            </li>
          </ul>
        </div>
        <div className="td_side_header_box">
          <h3 className="td_side_header_title td_heading_color">Subscribe</h3>
          <div className="td_newsletter td_style_1">
            <form className="td_newsletter_form">
              <input
                type="email"
                className="td_newsletter_input"
                placeholder="Email address"
                value={subscribeEmail}
                onChange={(e) => setSubscribeEmail(e.target.value)}
              />
              <button
                onClick={handleSubscribe}
                className="td_btn td_style_1 td_radius_30 custom-td_style_1 td_medium bg-transparent"
              >
                <span className="td_btn_in custom_td_btn_in">
                  <span>Subscribe</span>
                </span>
              </button>
            </form>
          </div>
        </div>
        <div className="td_side_header_box">
          <h3 className="td_side_header_title td_heading_color">Follow Us</h3>
          <div className="td_social_btns td_style_1 td_heading_color">
            <a
              href={companyDetailsData[0]?.facebook_link}
              className="td_center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a
              href={companyDetailsData[0]?.instagram_link}
              className="td_center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a
              href={companyDetailsData[0]?.x_link}
              className="td_center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>
            <a
              href={companyDetailsData[0]?.linkedin_link}
              className="td_center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
